"use strict";

if (!c.Server) {
  c.Server = {};
}
class Notification {
  constructor(name, options) {
    this.name = name;
    if (options == null) {
      options = {};
    }
    this.options = options;
  }
  notify(extra_params) {
    if (extra_params == null) {
      extra_params = {};
    }
    return jQuery.ajax({
      url: $r.api_v0_active_support_notifications_path({
        subdomain_param: "api"
      }),
      contentType: "application/x-www-form-urlencoded; charset=UTF-8",
      data: jQuery.extend(extra_params, {
        name: this.name
      }),
      type: "POST",
      statusCode: {
        401: () => {
          if (this.options._second_try) {
            return;
          }
          return new c.Server.Notification(this.name, jQuery.extend(this.options, {
            _second_try: true
          })).notify(extra_params);
        }
      }
    });
  }
}
c.Server.Notification = Notification;
window.Notification = Notification;